module.exports = __webpack_public_path__ + "static/media/CHAP01-EXERGUE-TURKINATOR.1cba0adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP01-EXERGUE-TURKINATOR.png
// module id = 251
// module chunks = 0